import { gql } from '@apollo/client';

export const SAVE_METADATA_LIST = gql`
  mutation saveMetadataList($input: [MetadataInput]) {
    saveMetadataList(input: $input) {
      commandId
      correlationId
    }
  }
`;
